export enum VectorPhraseSearchOptions {
    Agent = "isAgentSearch",
    Customer = "isCustomerSearch",
    Bot = "isBotSearch",
    System = "isSystemSearch",
    InteractionDetails = "isMetadataSearch",
}
